<app-layout [type]="layoutType">
  <div id="login">
    <h1>{{ titleKey | translate }}</h1>
    <app-icon-title-underline />

    @if (this.versionService.current !== "nsgo") {
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      @if (accountActivated) {
      <div class="activated-notice" role="status" data-testid="login-account-activated">
        <app-icon-check-circle />
        <div>
          <p class="activated-title">{{ 'login.accountActivated.title' | translate }}</p>
          <p>{{ 'login.accountActivated.text' | translate }}</p>
        </div>
      </div>
      }
      <app-input label="login.email" [formGroup]="form" name="email" type="email" [required]="true"></app-input>

      @if (!this.modernAuthFlow || showPasswordField) {
      <app-input label="login.password" [formGroup]="form" name="password" type="password"
        [required]="true"></app-input>
      }

      @if (error) {
      <div class="error-message" data-testid="login-error">
        <app-icon-warning />&nbsp;
        {{error}}
      </div>
      }

      @if (verificationCodeSent) {
      <div class="success-message" data-testid="login-verification-sent">
        <app-icon-warning />&nbsp;
        {{verificationCodeSent}}
      </div>
      }

      @if (form.get('email')?.invalid && form.get('email')?.touched) {
      <div class="error-message">
        <app-icon-warning />&nbsp;
        {{ 'login.emailRequired' | translate }}
      </div>
      }

      @if (form.get('password')?.invalid && form.get('password')?.touched) {
      <div class="error-message">
        <app-icon-warning />&nbsp;
        {{ 'login.passwordRequired' | translate }}
      </div>
      }


      @if (availableMethods.length > 0) {
      <div class="auth-methods">
        @for (method of availableMethods; track method) {
        <app-button variant="accent">
          <button type="button" [attr.data-testid]="'login-method-' + method" (click)="selectAuthMethod(method)">
            {{ 'login.method.' + method | translate }}
          </button>
        </app-button>
        }
      </div>
      }

      @if (showCaptchaChallenge) {
      <p class="captcha-challenge-hint">{{ 'login.captchaChallenge' | translate }}</p>
      }
      <div #captchaContainer class="captcha-challenge" data-testid="login-captcha" [hidden]="!showCaptchaChallenge"></div>

      <div class="button-group">
        <div class="action">
          @if(loading) {
          <app-spinner></app-spinner>
          } @else if (availableMethods.length === 0 && !showCaptchaChallenge) {
          <app-button variant="accent">
            <button type="submit" data-testid="login-submit">{{ this.modernAuthFlow ? 'login.submitModern' :
              'login.submit' | translate }}
            </button>
          </app-button>
          }
        </div>
        <app-button variant="secondary">
          <a routerLink="/forgot-password" queryParamsHandling="preserve" class="btn btn-secondary">{{
            'login.forgotPassword' | translate }}</a>
        </app-button>
      </div>

      @if (canRegister()) {
      <p class="register-link">
        {{ 'login.registerIntro' | translate }}
        <a routerLink="/register" queryParamsHandling="preserve" class="link">{{ 'login.registerLinkText' | translate
          }}</a>
      </p>
      }
    </form>
    } @else {
    <div class="social-login">
      <app-button variant="primary">
        <button type="button" data-testid="login-sso" (click)="triggerSso()">
          {{ 'login.ssoButton' | translate }}
        </button>
      </app-button>
    </div>
    }
  </div>
</app-layout>